// ! Lembrar de alinhar sempre ao que tem no BACKEND
const OrderEnum = {
  'NÃO ATENDIDA': 1,
  'PARCIALMENTE ATENDIDA': 2,
  'TOTALMENTE ATENDIDA': 3,
  CANCELADO: 4,
  'ALUGADO A PARTIR DA SUBSTITUIÇÃO': 5,
}

export default OrderEnum

export const OrderSituationEnum = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  CANCELLED: 'cancelled',
})

export const getOrderSituationKey = (value) =>
  Object.entries(OrderSituationEnum).find(([, v]) => v === value)?.[0] ?? value

export const getOrderSituationLabel = (value) => {
  const labels = {
    [OrderSituationEnum.PENDING]: 'Pendente',
    [OrderSituationEnum.APPROVED]: 'Aprovado',
    [OrderSituationEnum.CANCELLED]: 'Cancelado',
  }

  return labels[value] ?? value
}
